module.exports = __webpack_public_path__ + "static/media/FeedTime_ios_2_preview.7e6b6000.jpg";